<template>
  <div class="main yan-hua-home">
    <div class="banner">
      <img class="banner-img" :src="data.logo" alt />
      <div class="apply-button" style="text-align: center;">
        <el-button
          v-if="isJoin * 1"
          size="medium"
          style="width: 250px;font-size: 17px;height: 45px;"
          type="primary"
          round
          @click="$parent.$parent.joinApply"
        >立即报名</el-button>
        <!-- <el-button
          v-if="isJoin * 1"
          size="medium"
          style="width: 250px;font-size: 17px;height: 45px;"
          type="info"
          round
        >即将开始报名</el-button> -->
      </div>
    </div>
    <div class="introduced scc-container">
      <h2>{{id | getTitle}}介绍</h2>
      <div class="introduced-text" v-html="data.description"></div>
      <div class="date" v-if="showTime">
        <h3>距离会议开始还剩：</h3>
        <el-row :gutter="5">
          <el-col :span="6">
            <div class="date-item">
              <el-progress color="#fea302" :show-text="false" :percentage="d>0?100:0" type="circle"></el-progress>
              <div class="date-item-text">
                <p>{{d>=10?d:'0'+d}}</p>
                <p>DAYS</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="date-item">
              <el-progress color="#c3d500" :show-text="false" :percentage="Math.floor(h/24*100)" type="circle"></el-progress>
              <div class="date-item-text">
                <p>{{h>=10?h:'0'+h}}</p>
                <p>HOURS</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="date-item">
              <el-progress color="#2bb9ef" :show-text="false" :percentage="Math.floor(m/60*100)" type="circle"></el-progress>
              <div class="date-item-text">
                <p>{{m>=10?m:'0'+m}}</p>
                <p>MINUTES</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="date-item">
              <el-progress color="#f1d65b" :show-text="false" :percentage="Math.floor(s/60*100)" type="circle"></el-progress>
              <div class="date-item-text">
                <p>{{s>=10?s:'0'+s}}</p>
                <p>SECONDS</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="20">
        <el-col v-for="(i,index) in imgs" :key="index" :span="24/imgs.length">
          <img class="introduced-img" :src="i.logo" alt="">
          <!-- <div
            class="introduced-item yan-hua-home-introduced-item"
            :style="'background-image: url('+ i.logo +');'"
          ></div> -->
          <div v-if="i.title" class="introduced-title">{{i.title}}</div>
          <div v-if="i.description" class="introduced-description">{{i.description}}</div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="11">
        <el-col v-for="(i,index) in imgs" :key="index" :span="24/imgs.length">
          <div class="introduced-item" :style="'background-image: url('+ i +');'"></div>
        </el-col>
      </el-row> -->
      <div v-if="video" class="video-box">
        <i v-show="videoPlay" @click="playPause" class="el-icon-video-play"></i>
        <video
          id="video"
          v-if="video"
          class="introduced-video"
          controls
          :src="video"
          :poster="data.videoLogo"
        ></video>
      </div>
    </div>
    <div class="broadcastSchedule scc-container" v-if="scheduleList && scheduleList.length > 0">
      <h2>直播日程</h2>
      <div v-for="(item,index) in scheduleList" :key="index">
        <div v-if="item.length > 0">
          <TabList   :scheduleList="item" :tableListData="item[0].event" :title="id" :indexId="id - 1"/>
        </div>
      </div>
    </div>
    <div class="guestSpeaker scc-container" v-if="guestListShow && guestListShow.length > 0">
      <h2>演讲嘉宾</h2>
      <el-row :gutter="10">
        <el-col :span="6" v-for="(item,index) in guestListShow" :key="index">
          <div class="img-card">
            <img @click="open(item.id)" :src="item.logo" alt />
            <div class="img-text">
              <h5>{{$i18n.locale == 'zh'? item.name:item.nameEn}}</h5>
              <p>{{$i18n.locale == 'zh'? item.company:item.companyEn}}</p>
              <div v-if="item.titles">
                <p v-for="(i,index) in item.titles.split(' ')" :key="index">{{i}}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- <div style="text-align: center;">
        <el-button
          @click="showMore"
          style="color: #17AAF0;border: 1px solid #17AAF0;width: 180px"
          round
          plain
          v-show="guestListShow.length < guestList.length"
        >查看更多</el-button>
      </div>-->
    </div>
    <div class="moreInformaton" v-if="newsList.length > 0">
      <div class="scc-container">
        <h2>更多资讯</h2>
        <el-row :gutter="10">
          <!-- data.news -->
          <el-col :span="6" v-for="(i,j) in newsList" :key="j">
            <a :href="i.source" target="_blank">
              <div
                class="live-item"
                :style="'background-image:url(' +  i.logo + ');position:relative;'"
              >
                <div class="live-item-title">{{i.title}}</div>
              </div>
            </a>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog custom-class="tc" append-to-body :visible.sync="centerDialogVisible" center>
      <div class="hexagonsexangle">
        <img :src="$i18n.locale == 'zh'? guestDetail.logo:guestDetail.logo" alt />
      </div>
      <div class="tc-content">
        <h2>{{$i18n.locale == 'zh'? guestDetail.name:guestDetail.nameEn}}</h2>
        <p class="company">{{$i18n.locale == 'zh'? guestDetail.company:guestDetail.companyEn}}</p>
        <p class="company">{{$i18n.locale == 'zh'? guestDetail.titles:guestDetail.titlesEn}}</p>
        <div class="border"></div>
        <p v-html="$i18n.locale == 'zh'? guestDetail.summary:guestDetail.summaryEn"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { callApi } from "../api/callApi";
import { mapGetters } from "vuex";
import TabList from "../components/TabList";
export default {
  props: {
    id: {
      type: Number,
      default: 1
    },
    // imgs: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   }
    // }
  },
  components: {
    TabList
  },
  filters: {
    getTitle(id) {
      return id == 1
        ? "嵌入式物联网场次"
        : id == 2
        ? "工业物联网场次"
        : "智慧城市场次";
    }
  },
  watch: {
    scheduleList(val) {
      this.$nextTick(() => {
        var youVideo = document.getElementsByTagName("video")[0];
        if (youVideo) {
          youVideo.addEventListener("play", this.hide);
          youVideo.addEventListener("pause", this.show);
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      isJoin: "isJoin"
    })
  },
  data() {
    return {
      showTime: true,
      time: null,
      d: "",
      h: "",
      m: "",
      s: "",
      startTime: "",
      imgs: [
      ],
      active: 0,
      radio1: 0,
      scheduleList: [],
      guestList: [],
      guestListShow: [],
      newsList: [],
      index: 12,
      data: {},
      partner: "",
      centerDialogVisible: false,
      guestDetail: "", // 嘉宾详情，
      video: "",
      videoPlay: true
    };
  },
  methods: {
    countTime() {
      //获取当前时间
      let date = new Date();
      let now = date.getTime();
      //设置截止时间
      // let newTime = this.startTime + ''
      let endDate = new Date(this.startTime);
      let end = endDate.getTime();
      //时间差
      let leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24); //天数我没用到，暂且写上
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.s = Math.floor((leftTime / 1000) % 60);
      }else{
        this.showTime = false
      }
      //递归每秒调用countTime方法，显示动态时间效果
    },
    playPause() {
      var myVideo = document.getElementsByTagName("video")[0];
      if (myVideo.paused) {
        myVideo.play();
      } else {
        myVideo.pause();
      }
    },
    // showMore() {
    //   if (this.index < this.guestList.length) {
    //     this.index += 12;
    //     this.guestListShow = this.guestList.slice(0, this.index);
    //   }
    // },
    open(id) {
      let ID = { id };
      this.$c(this.$g.HOME_GET_GUEST_DETAIL, ID).then(res => {
        this.guestDetail = res.data;
        if (res.data.summary) {
          this.guestDetail.summary = res.data.summary.replace(/\n/g, "<br>");
        }
        if (res.data.guestDetailEn) {
          this.guestDetailEn.summary = res.data.guestDetailEn.replace(
            /\n/g,
            "<br>"
          );
        }
      });
      this.centerDialogVisible = true;
    },
    hide() {
      this.videoPlay = false;
    },
    show() {
      this.videoPlay = true;
    }
  },
  async created() {
    this.time = setInterval(this.countTime, 1000);
    await this.$c(this.$g.getOtherHomeInfo, { index: this.id }).then(res => {
      if (res.code == 200) {
        this.data = res.data;
        this.scheduleList = res.data.scheduleList;
        this.guestList = res.data.guestList;
        this.guestListShow = this.guestList;
        this.newsList = res.data.news;
        this.video = res.data.video;
        this.partner = res.data.partnerPc;
        this.startTime = res.data.startTime;
        this.imgs = res.data.exhibitors;
      }
    });
  },
  mounted() {},
  updated() {},
  beforeDestroy: function() {
    if (this.time) {
      clearInterval(this.time);
    }
    var youVideo = document.getElementsByTagName("video")[0];
    if (youVideo) {
      youVideo.removeEventListener("play", this.hide);
      youVideo.removeEventListener("pause", this.show);
    }
  },
  destroyed() {}
};
</script>
<style lang="less">
.date {
  width: 50%;
  margin: 40px auto;
  h3{
    text-align: center;
    margin-bottom: 20px;
  }
  .date-item {
    position: relative;
    .date-item-text {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      p{
        &:first-child{
          font-weight: bold;
          font-size: 24px;
        }
      }
    }
  }
}
.banner {
  position: relative;
  .apply-button {
    width: 100%;
    position: absolute;
    bottom: 90px;
  }
}
.video-box {
  position: relative;
  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    font-size: 70px;
    z-index: 10;
    color: white;
  }
}
.broadcastSchedule {
  margin-bottom: 10px;
}
.introduced {
  .introduced-img{
    //  height: 200px;
     width: 100%;
  }
  .introduced-title{
    background: #2bb9ef;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    padding: 5px;
    margin-bottom: 13px;
  }
  .introduced-description{
    font-size: 18px;
  }
  .introduced-item {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    font-size: 17px;
    text-align: center;
    // border: 1px solid #0c97d9;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: bold;
    color: #000015;
    border-radius: 3px;
    p {
      &:first-child {
        font-size: 26px;
      }
    }
  }
  .introduced-video {
    width: 100%;
    border-radius: 10px;
  }
}
.yan-hua-home {
  margin-bottom: 40px;
  .lable-group {
    margin-top: 72px;
    .el-radio-group {
      flex: 1;
      margin-bottom: -1px;
    }
    .el-radio-button {
      width: 100%;
    }
    .el-radio-button__inner {
      width: 100%;
      border-radius: inherit !important;
      height: 40px;
      line-height: 19px;
      color: rgba(23, 170, 240, 1);
      font-size: 15px;
      position: relative;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: rgba(255, 255, 255, 1);
    }
  }
}
@import "@/style/variable.less";
</style>
<style scoped lang="less">
@import "@/style/variable.less";
.hexagonsexangle {
  position: absolute;
  top: 36px;
  left: 46px;
  border-radius: 50%;
  width: 165px;
  height: 165px;
  overflow: hidden;
  img {
    height: 100%;
    width: 100%;
  }
}

.tc-content {
  padding: 14px 89px 110px 262px;
  h2 {
    text-align: left;
    font-weight: 500;
    color: rgba(34, 34, 34, 1);
    font-size: 33px;
    line-height: 33px;
  }

  p {
    font-weight: 300;
    line-height: 2;
    font-size: 13px;
    color: rgba(98, 98, 98, 1);
  }

  .company {
    font-size: 15px;
    line-height: 15px;
    margin-top: 12px;
    font-weight: 300;
    color: rgba(34, 34, 34, 1);
  }

  .border {
    width: 100%;
    border-top: 1px solid rgba(217, 221, 245, 1);
    margin: 36px 0;
  }
}
.guestSpeaker,
.partner {
  h2 {
    margin-bottom: 82px;
  }
}
.partner-img {
  width: 100%;
}
.scc-container {
  padding-top: 50px;
}
.introduced {
  .introduced-text {
    font-size: 18px;
    margin: 40px 0;
  }
  .introduced-video {
    margin: 40px 0 0 0;
  }
}
.banner {
  .banner-img {
    width: 100%;
  }
}
.moreInformaton {
  background-color: rgba(247, 249, 253, 1);
  padding-bottom: 124px;
  h2 {
    margin-bottom: 82px;
  }
  .live-item {
    height: 171px;
    margin-bottom: 5px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: #d6d6d6;
    .live-item-title {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      font-size: 17px;
      font-weight: bold;
      color: #ffffff;
      padding: 15px;
      background: rgba(133, 133, 133, 0.5);
      box-sizing: border-box;
    }
  }
}
.img-card {
  flex: 0 0 25%;
  padding-bottom: 40px;
  height: 330px;
  box-sizing: border-box;
  text-align: center;
  img {
    width: 170px;
    height: 170px;
    border-radius: 50%;
    cursor: pointer;
    display: inline-block;
  }
}

.img-text {
  text-align: center;
  margin-top: 20px;
  padding-left: 20px;
  color: @normal-text;
  width: 250px;
  box-sizing: border-box;
  h5 {
    font-size: 17px;
    margin-bottom: 5px;
    color: @bold-text;
  }
  p {
    font-size: 13px;
  }
}
.el-icon-time:before {
  font-weight: bold;
  margin-right: 5px;
}
h2 {
  font-size: 27px;
  text-align: center;
  color: #343434;
}
.lable-group {
  display: flex;
  align-items: flex-end;
}
</style>



